import React, { Fragment } from 'react';
import Logo from '../../client/src/icons/diamond-h.png';


import { BrowserRouter as Router, Route } from 'react-router-dom';

import Join from './components/Join/Join';
import Chat from './components/Chat/Chat';
import Header from './components/Header/Header';

const App = () => (
    <Fragment>
           <link rel="icon" href={Logo}></link>

    <Header />
    <Router>
        <Route path='/' exact component={Join} />
        <Route path='/chat' component={Chat} />
    </Router>
    </Fragment>
)
export default App